import './Button.scss';

export default function Button({ children, textOnly, className, ...props }) {
    let cssClasses = textOnly ? 'app-ui-text-button' : 'app-ui-button';
    cssClasses += ' ' + className;
    return (
        <button className={cssClasses} {...props}>{children}</button>
    )
}